export default "__VITE_ASSET__Bg49o5YG__"